import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { LIGHT, bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'eredivisie';
const { uniform } = leagueBuilder(ID);

const teams = [
  team('ajax', 'Ajax', uniform('ajax', '#D2122E', '#000000')),
  team('az', 'AZ', uniform('az', '#FF001C', '#FFFFFF')),
  team('sc-cambuur', 'SC Cambuur', uniform('sc-cambuur', '#FDE800', '#DDDDDD')),
  team('ado-den-haag', 'ADO Den Haag', uniform('ado-den-haag', '#00571E', '#FFE500')),
  team('excelsior', 'Excelsior', uniform('excelsior', '#000000', '#FF0014')),
  team('fc-groningen', 'FC Groningen', uniform('fc-groningen', '#009D61', '#FFFFFF')),
  team('feyenoord', 'Feyenoord', uniform('feyenoord', '#FB1D26', '#000000')),
  team('fortuna-sittard', 'Fortuna Sittard', uniform('fortuna-sittard', '#FFE000', '#00684C')),
  team('go-ahead-eagles', 'Go Ahead Eagles', uniform('go-ahead-eagles', '#FFE100', '#F3000F')),
  team('heerenveen', 'Heerenveen', uniform('heerenveen', '#004EA3', '#000000')),
  team('nec-nijmegen', 'NEC Nijmegen', uniform('nec-nijmegen', '#FF161F', '#009D67')),
  team('psv', 'PSV', uniform('psv', '#FF161F', '#000000')),
  team('sc-telstar', 'SC Telstar', uniform('sc-telstar', '#0078C4', '#FF141F')),
  team('sparta-rotterdam', 'Sparta Rotterdam', uniform('sparta-rotterdam', '#FF1637', '#000000')),
  team('fc-twente', 'FC Twente', uniform('fc-twente', '#FF0014', LIGHT)),
  team('fc-utrecht', 'FC Utrecht', uniform('fc-utrecht', '#FF011E', '#FFFFFF')),
  team('willem-ii', 'Willem II', uniform('willem-ii', '#1A2851', '#DB1212')),
  team('pec-zwolle', 'PEC Zwolle', uniform('pec-zwolle', '#005DAC', '#000000'))
];

export const eredivisie: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(35, 44, 351, 205) },
  teams
};
